export interface IPaginationResponse {
  totalResults: number
  results: number
  pageSize: number
  page: number
  totalPages: number
}
